import React, {useEffect} from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {Suspense} from "react";
import AboutUs from "./components/newpage/AboutUs";
import Contacts from "./components/newpage/Contacts";
import Footer from "./components/newpage/Footer";
import Home from "./components/newpage/Home";
import Header from "./components/newpage/Header";
import ScrollToTop from "./components/additional/ScrollToTop";
import Faq from "./components/additional/Faq";
import Rent from "./components/newpage/Rent";
import NotFound from "./components/additional/NotFound";
import Review from "./components/additional/Review";
import Blog from "./components/newpage/Blog";
import ChooseUs from "./components/additional/ChooseUs";
import OurSpace from "./components/additional/OurSpace";
import FreeConsult from "./components/additional/FreeConsult";
import LegalService from "./components/additional/LegalService";
import SalesProcess from "./components/additional/SalesProcess";
import Sale from "./components/newpage/Sale";
import {useTranslation} from "react-i18next";
import {routes} from "./routes";
import EstateDetail from "./components/newpage/EstateDetail";
import i18n from 'i18next';
import LanguageSync from "./LanguageSync";
import EstateList from "./components/newpage/EstateList";
import Search from "./components/newpage/Search";
import {ToastContainer} from "react-toastify";
import {ContactInfoProvider} from "./components/additional/ContactInfoContext";
import Business from "./components/newpage/Business";
import Favorites from "./components/newpage/Favorites";
import SitemapViewer from "./components/additional/SitemapViewer";
import Exclusive from "./components/newpage/Exclusive";

const languages = ["en", "ru", "hy"];

function App() {
    const {t} = useTranslation(["home"]);

    if (window.location.pathname === "/") {
        window.location.replace(`/${i18n.language}`);
    }

    // useEffect(() => {
    //     const lang = i18n.language;
    //
    //     if (lang === 'hy') {
    //         document.body.style.fontFamily = 'Bokonique-Regular';
    //     } else if (lang === 'ru') {
    //         document.body.style.fontFamily = 'Athena-Regular';
    //     } else {
    //         document.body.style.fontFamily = 'Bokonique-Regular';
    //     }
    // }, [i18n.language]);

    return (
        <Suspense fallback={null}>
            <ContactInfoProvider>
                <Router>
                    <LanguageSync/>
                    <Header/>
                    {/*<ScrollToTop>*/}
                        <Routes>
                            {/* <Route index element={<Home />} /> */}
                            <Route path='/hy' element={<Home/>}/>
                            <Route path='/en' element={<Home/>}/>
                            <Route path='/ru' element={<Home/>}/>

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-about`}
                                    path={`/:language/${routes.about[lng]}`}
                                    element={<AboutUs/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-contacts`}
                                    path={`/:language/${routes.contacts[lng]}`}
                                    element={<Contacts/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-faq`}
                                    path={`/:language/${routes.faq[lng]}`}
                                    element={<Faq/>}
                                />
                            ))}
                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-chooseUs`}
                                    path={`/:language/${routes.chooseUs[lng]}`}
                                    element={<ChooseUs/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-consultation`}
                                    path={`/:language/${routes.consultation[lng]}`}
                                    element={<FreeConsult/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-legalservice`}
                                    path={`/:language/${routes.legalservice[lng]}`}
                                    element={<LegalService/>}
                                />
                            ))}
                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-salesprocces`}
                                    path={`/:language/${routes.salesprocces[lng]}`}
                                    element={<SalesProcess/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-review`}
                                    path={`/:language/${routes.review[lng]}`}
                                    element={<Review/>}
                                />
                            ))}

                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-ourspace`}
                                    path={`/:language/${routes.ourspace[lng]}`}
                                    element={<OurSpace/>}
                                />
                            ))}
                            {languages.map((lng) => (
                                <Route
                                    key={`${lng}-blog`}
                                    path={`/:language/${routes.blog[lng]}`}
                                    element={<Blog/>}
                                />
                            ))}


                            <Route path="*" element={<NotFound/>}/>


                            {languages.map((language) => (
                                <Route
                                    key={`${language}-sales`}
                                    path={`/:language/${routes.sales[language]}`}
                                    element={<Sale/>}
                                />
                            ))}
                            {languages.map((language) => (
                                <Route
                                    key={`${language}-rent`}
                                    path={`/:language/${routes.rent[language]}`}
                                    element={<Rent/>}
                                />
                            ))}
                            {languages.map((language) => (
                                <Route
                                    key={`${language}-business`}
                                    path={`/:language/${routes.business[language]}`}
                                    element={<Business/>}
                                />
                            ))}
                            {languages.map((language) => (
                                <Route
                                    key={`${language}-exclusive`}
                                    path={`/:language/${routes.exclusive[language]}`}
                                    element={<Exclusive/>}
                                />
                            ))}
                            {languages.map((language) => (
                                <Route
                                    key={`${language}-search`}
                                    path={`/:language/${routes.search[language]}`}
                                    element={<Search/>}
                                />
                            ))}
                            {languages.map((language) => (
                                <Route
                                    key={`${language}-favorites`}
                                    path={`/:language/${routes.favorites[language]}`}
                                    element={<Favorites/>}
                                />
                            ))}

                            <Route path="/:language/:baseUrl/:id" element={<EstateDetail/>}/>

                            {/*<Route path="/:lang/sitemap.xml" element={<SitemapViewer />} />*/}

                            {/*{languages.map((language) => (*/}
                            {/*    <Route*/}
                            {/*        key={`${language}-estate-detail`}*/}
                            {/*        path={`/:language/:type/:id`}*/}
                            {/*        element={<EstateList/>}*/}
                            {/*    />*/}
                            {/*))}*/}

                        </Routes>
                    {/*</ScrollToTop>*/}
                    <Footer/>
                    <ToastContainer/>
                </Router>
            </ContactInfoProvider>
        </Suspense>
    );
}

export default App;
